import React from 'react'
import { useFormContext } from '@/providers';
import { Swiper, SwiperSlide } from "swiper/react"; // Import Swiper components
import "swiper/css"; // Import Swiper core CSS
import "swiper/css/navigation"; // Import Swiper navigation styles
import "swiper/css/pagination"; // Import Swiper pagination styles
import { renderImage } from '@/constants';
import { MdGroup, MdOutlineBedroomParent } from 'react-icons/md';
import { FaShower } from 'react-icons/fa';

export const ListingCard = () => {
    const { watch } = useFormContext();

    const title = watch('title');

    return (
        <div className="w-full overflow-hidden bg-white rounded-lg shadow-lg group">
            {/* Image Section with Swiper */}
            <div className="relative w-full h-full">
                <Swiper
                    spaceBetween={10}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{ delay: 5000 }}
                    className="w-full h-full"
                >
                    {/* Loop through images dynamically */}
                    {watch('images')?.map((image, index) => (
                        <SwiperSlide key={index}>
                            <img
                                className="object-cover w-full h-full"
                                src={renderImage(image.data_url) || renderImage(image.image) || renderImage(image.file_name)}
                                alt={title || "Listing Image"}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Overlay with Title and Number of Bedrooms */}
                <div className="absolute bottom-0 left-0 z-10 w-full px-4 py-3 text-white bg-gradient-to-t from-gray-900 to-transparent">

                    {/* Price */}
                    <h3 className="text-md font-bold text-white text-left !m-0">
                        ${watch('nightly_price')}
                        <span className="text-xs font-normal text-left text-white"> / Night</span>
                    </h3>

                    {/* Title */}
                    <h4 className="text-md font-bold text-white text-left !m-0 truncate">
                        {/* <Link to={`/listing/${e.id}`} className="text-left text-white hover:underline"> */}
                        {watch('title') || "(AXBD) Title"}
                        {/* </Link> */}
                    </h4>

                    {/* Location */}
                    <p className="text-xs text-gray-200 text-left !mb-[0] truncate">
                        {watch('city') || "City"}, {watch('state') || "State"}, {watch('country') || "Country"}
                    </p>

                    {/* Amenities */}
                    <div className="flex items-center mt-2 space-x-4 text-xs">
                        <div className="flex items-center space-x-1 truncate">
                            <MdOutlineBedroomParent />
                            <span className="text-white">{watch('no_of_bedrooms') || 0} Bedrooms</span>
                        </div>
                        <div className="flex items-center space-x-1 truncate">
                            <FaShower />
                            <span className="text-white">{watch('no_of_bathrooms') || 0} Baths</span>
                        </div>
                        <div className="flex items-center space-x-1 truncate">
                            <MdGroup />
                            <span className="text-white">{watch('no_of_guest') || 0} Guests</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
